<template>
  <div>
    <van-form :show-error="false" @submit="toSubmit">
      <van-field
        v-model="leaveForms.stuName"
        name="stuName"
        label="学生姓名"
        placeholder="学生姓名"
        required
        :rules="[
          {
            required: true,
            message: '请填写当前班级的学生姓名',
            validator: checkStuName,
          },
        ]"
      />
      <van-field
        readonly
        clickable
        name="classInfo"
        :value="leaveForms.classText"
        label="班级"
        placeholder="点击选择班级"
        @click="toShowPicker(0)"
        required
        :rules="[{ required: true, message: '请选择学生正确的班级' }]"
      />
      <van-field
        v-model="leaveForms.childNo"
        name="childNo"
        label="学号"
        placeholder="学生学号"
        required
        :rules="[{ required: true, message: '请填写学生学号' }]"
      />
      <van-field
        readonly
        clickable
        name="leaveType"
        :value="leaveForms.leaveType"
        label="请假类型"
        placeholder="点击选择请假类型"
        @click="toShowPicker(1)"
        required
        :rules="[{ required: true, message: '请选择请假类型' }]"
      />
      <van-field
        readonly
        clickable
        name="applyDate"
        :value="leaveForms.applyTime"
        label="请假申请日期"
        placeholder="请选择日期"
        @click="showCalendar = true"
        required
        :rules="[{ required: true, message: '请选择请假申请日期' }]"
      />
      <van-calendar v-model="showCalendar" @confirm="onConfirm" />
      <am-pm-date
        dateLable="请假开始日期"
        :startTime="leaveForms.startTime"
        :dataStr="['startTime', 'startStr']"
        @date-event="dateEvent"
      />
      <am-pm-date
        dateLable="请假结束日期"
        :dateStr="['endTime', 'endStr']"
        :startTime="leaveForms.startTime"
        @date-event="dateEvent"
      />
      <van-field
        v-model="leaveForms.daysOff"
        type="number"
        label="请假天数"
        required
        :rules="[{ required: true, message: '请输入请假天数' }]"
      />
      <van-field v-model="leaveForms.realtive" label="请假申请人与学生关系" />
      <van-field
        v-if="leaveForms.leaveType == '病假'"
        readonly
        clickable
        name="picker"
        :value="leaveForms.disease"
        label="病假症状"
        placeholder="请选择"
        @click="toShowPicker(2)"
        required
        :rules="[{ required: true, message: '请选择病假症状' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="leaveForms.temperature"
        type="number"
        label="体温(℃)"
        required
        :rules="[{ required: true, message: '请输入体温' }]"
      />
      <van-field
        v-model="leaveForms.reason"
        rows="2"
        autosize
        label="请假事由"
        type="textarea"
        placeholder="请输入"
        required
        :rules="[{ required: true, message: '请输入请假事由' }]"
      />
      <van-field
        v-model="leaveForms.remark"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        placeholder="请输入"
      />
      <van-field name="uploader" label="附件">
        <template #input>
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            :before-read="beforeRead"
            :max-count="2"
          />
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button round block color="#4aaca2" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast, Notify } from "vant";
import AmPmDate from "@/views/leave/components/AmPmDate.vue";
import { dateFormat, calcDate } from "@/util/date.js";
import { classNameRecursion } from "@/util/util";

export default {
  components: {
    AmPmDate,
  },
  data() {
    return {
      leaveForms: {
        stuName: "",
        studentId: "",
        startTime: "",
        startStr: "",
        endTime: "",
        endStr: "",
        classText: "",
        classId: "",
        childNo: "", //学号
        leaveType: "",
        applyTime: dateFormat(new Date()), //请假申请日期
        daysOff: 0, //请假天数
        disease: "",
        temperature: 37, //体温
        reason: "", //请假事由
        remark: "", //备注
        enclosure: "", //附件
        realtive: "", //请假申请人与学生关系
      },
      showPicker: false,
      showCalendar: false,
      columns: [],
      fileList: [],
      pickerType: 100,
      classColumns: [],
    };
  },
  computed: {},
  mounted() {
    this.getClassInfo();
    this.leaveForms.stuName = sessionStorage.stuName;
    this.leaveForms.studentId = sessionStorage.studentId;
    this.leaveForms.classText = sessionStorage.classText;
    this.leaveForms.classId = sessionStorage.classId;
    this.leaveForms.childNo = sessionStorage.childNo;
  },
  methods: {
    dateEvent(data) {
      for (const key in data) {
        this.leaveForms[key] = data[key];
      }
      console.log(new Date(this.leaveForms.startTime));
      this.leaveForms.daysOff = calcDate(
        this.leaveForms.startTime,
        this.leaveForms.startStr,
        this.leaveForms.endTime,
        this.leaveForms.endStr
      );
    },
    afterRead(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      this.axios({
        method: "post",
        url: "/api/blade-resource/oss/endpoint/put-file",
        herders: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then((res) => {
        // this.leaveForms.enclosure.push(res.data.data.link)
        file.message = res.data.data.link;
        console.log(res);
        console.log(this.fileList);
        this.leaveForms.enclosure = "";
        this.fileList.forEach((el) => {
          this.leaveForms.enclosure += el.message + "|";
        });
        console.log(this.leaveForms.enclosure);
      });
    },
    beforeRead(file) {
      var fileType = ["image/jpeg", "image/jpg", "image/png"];
      if (fileType.indexOf(file.type) == -1) {
        Toast("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    getClassInfo() {
      this.axios({
        url: "api/blade-food/class/getClasses",
        method: "get",
        params: {
          id: sessionStorage.schoolId,
        },
      })
        .then((res) => {
          var classInfo = res.data.data[0].children;
          this.classColumns = classNameRecursion(classInfo);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onConfirm(value, index) {
      console.log(value);
      console.log(this.pickerType);
      console.log(index);
      switch (this.pickerType) {
        case 0:
          if (value) {
            this.leaveForms.classText = value.join("/");
            var classColumns = this.classColumns;
            index.forEach((el) => {
              classColumns = classColumns[el];
              if (classColumns.children) {
                classColumns = classColumns.children;
              }
            });
            this.leaveForms.classId = classColumns.id;
            console.log(this.leaveForms);
          }
          break;
        case 1:
          this.leaveForms.leaveType = value;
          break;
        case 2:
          this.leaveForms.disease = value;
          break;
        default:
          break;
      }
      this.showPicker = false;
    },
    toShowPicker(type) {
      var symptoms = [
        "感冒",
        "咳嗽",
        "发热",
        "肠胃不适",
        "皮疹",
        "腹泻",
        "黄疸",
        "结膜红肿",
        "呕吐",
        "牙疼",
        "外伤",
        "咽喉",
        "其他",
      ];
      //请假类型
      var leaveInfo = ["事假", "病假"];
      switch (type) {
        case 0:
          this.columns = this.classColumns;
          this.pickerType = 0;
          break;
        case 1:
          this.columns = leaveInfo;
          this.pickerType = 1;
          break;
        case 2:
          this.columns = symptoms;
          this.pickerType = 2;
          break;
        default:
          break;
      }
      this.showPicker = true; //打开弹框
    },
    toSubmit() {
      this.axios({
        method: "post",
        url: "/api/blade-food/studentleave/ignore/save",
        data: this.leaveForms,
      })
        .then((res) => {
          console.log(res);
          Notify({ type: "success", message: "提交成功" });
          this.$emit("toHistoryPage");
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.msg) {
            Notify({ type: "danger", message: err.response.data.msg });
          } else {
            Notify({ type: "danger", message: "提交失败,请重试。" });
          }
        });
    },
    checkStuName() {
      return new Promise((resolve) => {
        this.axios({
          method: "get",
          url: "/api/blade-food/studentleave/ignore/check",
          params: {
            classId: this.leaveForms.classId,
            studentName: this.leaveForms.stuName,
            childNo: this.leaveForms.childNo,
          },
        })
          .then((res) => {
            console.log(res.data.data);
            if (res.data.data == -1) {
              resolve(false);
            } else {
              this.studentId = res.data.data;
              resolve(true);
            }
          })
          .catch((err) => {
            console.log(err);
            resolve(false);
          });
      }).catch((e) => {
        console.log(e);
      });
    },
  },
};
</script>

<style scoped>
</style>>

